import Ajv, { ErrorObject } from 'ajv'
import ajvErrors from 'ajv-errors'
import addFormats from 'ajv-formats'
import set from 'lodash/set'
import { dateBeforeField } from '../../../utils'

function ajvErrorsToFormik(errors: ErrorObject[] | null = []) {
  const formikErrors = {}

  errors?.forEach(err => {
    let path = err.instancePath.replace(/^\//, '').replace(/\//g, '.')

    if (err.keyword === 'required') {
      path = err.params.missingProperty
    }

    // Prefer a specific errorMessage within the 'then' block rather than
    // complaining that the 'if' condition is not met.
    if (err.keyword === 'if') {
      return
    }

    set(formikErrors, path, err.message)
  })

  return formikErrors
}

export const ajv = new Ajv({
  strict: false,
  allErrors: true,
  multipleOfPrecision: 8,
})
ajvErrors(ajv)
addFormats(ajv)
ajv.addKeyword(dateBeforeField)

export const jsonSchemaFormikValidator = (schema: object) => {
  return (values: any) => {
    const validate = ajv.compile(schema)

    const valid = validate(values)

    const formikErrors = ajvErrorsToFormik(validate.errors)

    return { valid: Boolean(valid), errors: formikErrors }
  }
}
